function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState, useRef } from "react";
var useData = function useData(projectId, _ref, appType) {
  var winnreNoAuth = _ref.winnreNoAuth,
    winnreAuth = _ref.winnreAuth;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    projectDetails = _useState2[0],
    setProjectDetails = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loadingProject = _useState4[0],
    setLoadingProject = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    highlightCategories = _useState6[0],
    setHighlightCategories = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    projectGallery = _useState8[0],
    setProjectGallery = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    VrGallery = _useState0[0],
    setVrGallery = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    constructionGallery = _useState10[0],
    setConstructionGallery = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    projectAmenities = _useState12[0],
    setProjectAmenities = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    projectAdditionalHighlights = _useState14[0],
    setProjectAdditionalHighlights = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    projectDocs = _useState16[0],
    setProjectDocs = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    projectBrochure = _useState18[0],
    setProjectBrochure = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    projectFaqs = _useState20[0],
    setProjectFaqs = _useState20[1];
  var isMountedRef = useRef(true);
  var getProjeHighlights = function getProjeHighlights() {
    var url = "/winnre/user/projectHighlight?projectId=".concat(projectId, "&pageNumber=0&pageSize=1000");
    winnreNoAuth.get(url).then(function (data) {
      if (!isMountedRef.current) return;
      var highlightCategorie = data.content.reduce(function (acc, curr) {
        if (acc[curr.title]) {
          acc[curr.title].push(curr);
          return acc;
        } else {
          acc[curr.title] = [curr];
          return acc;
        }
      }, {});
      setHighlightCategories(highlightCategorie);
    });
  };
  var getProjectAdditionalHighlights = function getProjectAdditionalHighlights() {
    var url = "/winnre/user/projectAdditionalHighlight?projectId=".concat(projectId, "&pageNumber=0&pageSize=1000");
    winnreNoAuth.get(url).then(function (data) {
      if (!isMountedRef.current) return;
      var additionalHighlights = data.content.reduce(function (acc, curr) {
        if (acc[curr.title]) {
          acc[curr.title].push(curr);
          return acc;
        } else {
          acc[curr.title] = [curr];
          return acc;
        }
      }, {});
      setProjectAdditionalHighlights(additionalHighlights);
    });
  };
  var getProjectAmenity = function getProjectAmenity() {
    var url = "/winnre/user/projectAmenity?projectId=".concat(projectId, "&pageNumber=0&pageSize=1000");
    winnreNoAuth.get(url).then(function (data) {
      if (!isMountedRef.current) return;
      setProjectAmenities(data.content);
    });
  };
  var getUrl = function getUrl(type) {
    return "/winnre/user/projectGallery/type?galleryType=".concat(type, "&projectId=").concat(projectId, "&sortBy=updatedOn&isAscending=false&pageNumber=0&pageSize=50");
  };
  var getProjectGallery = function getProjectGallery() {
    winnreNoAuth.get(getUrl("GALLERY")).then(function (res) {
      if (!isMountedRef.current) return;
      setProjectGallery(res === null || res === void 0 ? void 0 : res.content);
    });
    winnreNoAuth.get(getUrl("CONSTRUCTION_PROGRESS")).then(function (res) {
      if (!isMountedRef.current) return;
      setConstructionGallery(res === null || res === void 0 ? void 0 : res.content);
    });
    winnreNoAuth.get(getUrl("AR_VR")).then(function (res) {
      if (!isMountedRef.current) return;
      setVrGallery(res === null || res === void 0 ? void 0 : res.content);
    });
  };
  var getProjectDetails = function getProjectDetails() {
    setLoadingProject(true);
    var url = "/winnre/user/project/".concat(projectId);
    winnreNoAuth.get(url).then(function (data) {
      if (!isMountedRef.current) return;
      setLoadingProject(false);
      setProjectDetails(data);
    });
  };
  var getProjectDocuments = function getProjectDocuments() {
    var url = "/winnre/user/project/documents/".concat(projectId);
    winnreNoAuth.get(url).then(function (data) {
      if (!isMountedRef.current) return;
      setProjectDocs(data);
    });
  };
  var getProjectBrochure = function getProjectBrochure() {
    var url = "/winnre/user/projectBrochure?projectId=".concat(projectId, "&pageSize=30&pageNumber=0");
    var axiosInstance = appType === "winnre" ? winnreAuth : winnreNoAuth;
    axiosInstance.get(url).then(function (data) {
      console.log("faqs->", data);
      if (!isMountedRef.current) return;
      if (data.status === "FAILED") {
        setProjectBrochure([]);
        return;
      }
      setProjectBrochure(data.content);
    });
  };
  var getProjectFaqs = function getProjectFaqs() {
    var url = "/winnre/user/projectFaq?projectId=".concat(projectId, "&pageNumber=0&pageSize=1000");
    winnreNoAuth.get(url).then(function (data) {
      if (!isMountedRef.current) return;
      if (data.status === "FAILED" || !data.content) {
        setProjectFaqs([]);
        return;
      }
      setProjectFaqs(data.content);
    });
  };
  useEffect(function () {
    if (!projectId) return;
    isMountedRef.current = true;
    getProjectDetails();
    getProjeHighlights();
    getProjectAdditionalHighlights();
    getProjectGallery();
    getProjectAmenity();
    getProjectDocuments();
    getProjectBrochure();
    getProjectFaqs();
    return function () {
      isMountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);
  return {
    projectDetails: projectDetails,
    highlightCategories: highlightCategories,
    projectAdditionalHighlights: projectAdditionalHighlights,
    projectAmenities: projectAmenities,
    projectGallery: projectGallery,
    constructionGallery: constructionGallery,
    VrGallery: VrGallery,
    projectDocs: projectDocs,
    projectBrochure: projectBrochure,
    projectFaqs: projectFaqs,
    loadingProject: loadingProject
  };
};
export default useData;